var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star/activated"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 10.9502L3.87713 12.5436C3.50946 12.7313 3.08567 12.4177 3.1575 12.0113L3.75 8.65836L1.25401 6.29695C0.949752 6.00909 1.11307 5.49713 1.52781 5.43864L4.99139 4.95016L6.55431 1.8765C6.73965 1.512 7.26035 1.512 7.44569 1.8765L9.00861 4.95016L12.4722 5.43864C12.8869 5.49713 13.0502 6.00909 12.746 6.29695L10.25 8.65836L10.8425 12.0113C10.9143 12.4177 10.4905 12.7313 10.1229 12.5436L7 10.9502Z",
    fill: "#FFBA49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.aa0a769c87dc7f0f7193e1d0ef770fcf.svg";
export { ForwardRef as ReactComponent };